// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"9556f618","91":"3bce6198","216":"490edaee","227":"e7c9722b","237":"45c6647a","244":"dbe0da74","417":"5fa56deb","582":"3b5e8e3b","638":"f4ae7436"}[chunkId] + ".chunk.js";
};